import { TbCalendar } from "react-icons/tb";
import { useRef } from "react";

interface TaskFormDateFieldsProps {
  formData: {
    start_date?: string;
    due_date?: string;
  };
  isViewMode: boolean;
  errors: Record<string, string>;
  onStartDateChange: (value: string) => void;
  onDueDateChange: (value: string) => void;
}

export const TaskFormDateFields: React.FC<TaskFormDateFieldsProps> = ({
  formData,
  errors,
  isViewMode,
  onStartDateChange,
  onDueDateChange,
}) => {
  const startDateRef = useRef<HTMLInputElement>(null);
  const endDateRef = useRef<HTMLInputElement>(null);

  const handleStartDateIconClick = () => {
    startDateRef.current?.showPicker();
  };

  const handleEndDateIconClick = () => {
    endDateRef.current?.showPicker();
  };

  return (
    <div className="box-border content-stretch flex flex-row gap-4 items-start justify-start p-0 relative shrink-0 w-full">
      <div className="basis-0 box-border content-stretch flex flex-col gap-1.5 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0">
        <div className="box-border content-stretch flex flex-row gap-2 items-center justify-start p-0 relative shrink-0">
          <div
            className="font-['Open_Sans:SemiBold',_sans-serif] font-semibold leading-[0] relative shrink-0 text-[#444444] text-[14px] text-left text-nowrap"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="leading-[1.5] whitespace-pre">
              <span>Start Date </span>
              <span className="text-[#e7000b]">*</span>
            </p>
          </div>
        </div>
        <div className="bg-gray-100 relative rounded-[10px] shrink-0 w-full">
          <div className="box-border content-stretch flex flex-row items-center justify-between px-3.5 py-[13px] relative w-full">
            <input
              ref={startDateRef}
              type="date"
              value={formData.start_date || ""}
              onChange={(e) => onStartDateChange(e.target.value)}
              className={`w-full bg-transparent border-none outline-none font-['Open_Sans:Medium',_sans-serif] leading-[1.5] not-italic text-[12px] text-left ${
                formData.start_date ? "text-gray-900" : "text-[#828282]"
              } 
              ${isViewMode ? "cursor-not-allowed" : ""} 
              ${
                errors.start_date ? "text-red-500" : ""
              } [&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:scale-0`}
              style={{
                colorScheme: "light",
              }}
              placeholder="dd/mm/yyyy"
              disabled={isViewMode}
            />
            <div
              className="overflow-clip relative shrink-0 size-4 cursor-pointer"
              onClick={handleStartDateIconClick}
            >
              <TbCalendar
                size={16}
                className={`text-[#828282] ${
                  isViewMode ? "cursor-not-allowed" : ""
                }`}
              />
            </div>
          </div>
        </div>
        {errors.start_date && (
          <p className="mt-1 text-xs text-red-600">{errors.start_date}</p>
        )}
      </div>

      <div className="basis-0 box-border content-stretch flex flex-col gap-1.5 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0">
        <div className="box-border content-stretch flex flex-row gap-2 items-center justify-start p-0 relative shrink-0">
          <div
            className="font-['Open_Sans:SemiBold',_sans-serif] font-semibold leading-[0] relative shrink-0 text-[#444444] text-[14px] text-left text-nowrap"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="leading-[1.5] whitespace-pre">
              <span>End Date </span>
              <span className="text-[#e7000b]">*</span>
            </p>
          </div>
        </div>
        <div className="bg-gray-100 relative rounded-[10px] shrink-0 w-full">
          <div className="box-border content-stretch flex flex-row items-center justify-between px-3.5 py-[13px] relative w-full">
            <input
              ref={endDateRef}
              type="date"
              value={formData.due_date || ""}
              onChange={(e) => onDueDateChange(e.target.value)}
              className={`w-full bg-transparent border-none outline-none font-['Open_Sans:Medium',_sans-serif] leading-[1.5] not-italic text-[12px] text-left ${
                formData.due_date ? "text-gray-900" : "text-[#828282]"
              } 
              ${isViewMode ? "cursor-not-allowed" : ""} 
              ${
                errors.due_date ? "text-red-500" : ""
              } [&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:scale-0`}
              style={{
                colorScheme: "light",
              }}
              placeholder="dd/mm/yyyy"
              disabled={isViewMode}
            />
            <div
              className="overflow-clip relative shrink-0 size-4 cursor-pointer"
              onClick={handleEndDateIconClick}
            >
              <TbCalendar
                size={16}
                className={`text-[#828282] ${
                  isViewMode ? "cursor-not-allowed" : ""
                }`}
              />
            </div>
          </div>
        </div>
        {errors.due_date && (
          <p className="mt-1 text-xs text-red-600">{errors.due_date}</p>
        )}
      </div>
    </div>
  );
};
